export default "__VITE_ASSET__Dj1U7U0i__"